(function(ngtk) {
    'use strict';

    function invertObject(o) {
        var result = {};
        angular.forEach(o, function(value, key) {
            result[value] = key;
        });
        return result;
    }

    var escapeMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#x27;',
        '`': '&#x60;'
    };
    var unescapeMap = angular.extend({
        '&nbsp;': "\u00A0"
    }, invertObject(escapeMap));

    var createEscaper = function(map) {
        var escaper = function(match) {
            return map[match];
        };
        var source = '(?:' + Object.keys(map).join('|') + ')';
        var testRegexp = new RegExp(source);
        var replaceRegexp = new RegExp(source, 'g');
        return function(string) {
            string = string == null ? '' : '' + string;
            return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
        };
    };
    var escapeHtml = createEscaper(escapeMap);
    var unescapeHtml = createEscaper(unescapeMap);

    var stringTools = {
        format: function(format) {
            var args = Array.prototype.slice.call(arguments, 1);
            return format.replace(/{(\d+)}/g, function(match, number) {
                return typeof args[number] != 'undefined' ? args[number] : match;
            });
        },
        parseTemplate: function(format, bindings, left, right, escape, notFoundBindings) {
            var string = '' + format;
            if (angular.isObject(left)) {
                notFoundBindings = left;
                left = undefined;
            } else if (angular.isObject(right)) {
                notFoundBindings = right;
                right = undefined;
            } else if (angular.isObject(escape)) {
                notFoundBindings = escape;
                escape = false;
            }
            angular.forEach(bindings, function(value, key) {
                if (escape) {
                    value = stringTools.escapeHtml('' + value);
                }
                var tokens = string.split((left || '{') + key + (right || left || '}'));
                if (tokens.length > 1) {
                    string = tokens.join(value);
                } else {
                    if (angular.isObject(notFoundBindings)) {
                        notFoundBindings[key] = value;
                    }
                }
            });
            return string;
        },
        ucfirst: function(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        lcfirst: function(string) {
            return string.charAt(0).toLowerCase() + string.slice(1);
        },
        random: function(length) {
            if (!length) {
                length = 16;
            }
            return Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
        },
        escapeHtml: escapeHtml,
        unescapeHtml: unescapeHtml,
        escapeRegexp: function(s) {
            return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        }
    };

    var mathTools = {
        randomInt: function() {
            var min = 0, max = 1;

            switch (arguments.length) {
                case 1:
                    max = arguments[0];
                    break;
                case 2:
                    min = arguments[0];
                    max = arguments[1];
                    break;
            }

            if (max < min) {
                var tmp = max;
                max = min;
                min = tmp;
            }

            return min + Math.round((max - min) * Math.random());
        },
        randomBoolean: function() {
            return Math.random() >= 0.5;
        },
        randomFromInterval: function(interval) {
            if (!isNaN(interval)) {
                return interval;
            }
            return interval.min + Math.round((interval.max - interval.min) * Math.random());
        },
        randomNotIn: function(items, min, max) {
            var uniqItems = arrayTools.unique(items);
            var maxRand = max - uniqItems.length;
            if (maxRand < min) {
                return undefined;
            }
            var randomValue = mathTools.randomInt(min, maxRand);
            uniqItems.sort(function(a, b) {
                return a - b;
            }).some(function(number) {
                if (randomValue < number) {
                    return true;
                } else {
                    ++randomValue;
                    return false;
                }
            });
            return randomValue;
        },
        intval: function(value, minValue) {
            if (angular.isUndefined(value)) {
                return value;
            }
            value = parseInt(value);
            if (isNaN(value)) {
                return undefined;
            }
            if (angular.isDefined(minValue) && value < minValue) {
                return undefined;
            }
            return value;
        }
    };

    var objectTools = {
        invert: invertObject,
        deepExtend: function deepExtend(dst, src) {
            Array.prototype.slice.call(arguments, 1).forEach(function(src) {
                angular.forEach(src, function(value, key) {
                    if (angular.isObject(dst[key]) && angular.isObject(value) && !angular.isArray(dst[key]) && !angular.isArray(value)) {
                        deepExtend(dst[key], value);
                    } else {
                        dst[key] = value;
                    }
                });
            });
            return dst;
        },
        empty: function(dst, dropHashKey) {
            Object.keys(dst).forEach(function(key) {
                if (key !== '$$hashKey' || dropHashKey) {
                    delete dst[key];
                }
            });
            return dst;
        },
        replace: function(dst, src, dropHashKey) {
            return angular.extend(objectTools.empty(dst, dropHashKey), src);
        },
        filter: function(src, filterFn) {
            return angular.isObject(src) ? Object.keys(src).reduce(function(carry, key) {
                return ((filterFn || angular.isDefined)(src[key], key) && (carry[key] = src[key])), carry;
            }, {}) : {};
        },
        getByPath: function(object, path) {
            if (!angular.isObject(object)) {
                return undefined;
            }
            if (!angular.isArray(path)) {
                path = path.split('.');
            }
            var element, ptr = object;
            while (element = path.shift()) {
                if (!angular.isDefined(ptr[element])) {
                    return undefined;
                }
                ptr = ptr[element];
            }
            return '' + ptr;
        },
        assignByPath: function(object, path, value) {
            if (!angular.isObject(object)) {
                throw new Error("Invalid argument: 'object' is not an object");
            }
            if (!angular.isArray(path)) {
                path = ('' + path).split('.');
            }
            var ptr = object;
            for (var i = 0; i < path.length - 1; ++i) {
                var key = path[i];
                if (!angular.isObject(ptr[key])) {
                    ptr[key] = {};
                }
                ptr = ptr[key];
            }
            ptr[path[path.length - 1]] = value;
            return ptr;
        },
        formEncode: function param(obj) {
            var query = '', name, value, fullSubName, subName, subValue, innerObj, i;

            for (name in obj) {
                if (!obj.hasOwnProperty(name)) {
                    continue;
                }
                value = obj[name];

                if (value instanceof Array) {
                    for (i = 0; i < value.length; ++i) {
                        subValue = value[i];
                        fullSubName = name + '[' + i + ']';
                        innerObj = {};
                        innerObj[fullSubName] = subValue;
                        query += param(innerObj) + '&';
                    }
                }
                else if (value instanceof Object) {
                    for (subName in value) {
                        if (!value.hasOwnProperty(subName)) {
                            continue;
                        }
                        subValue = value[subName];
                        fullSubName = name + '[' + subName + ']';
                        innerObj = {};
                        innerObj[fullSubName] = subValue;
                        query += param(innerObj) + '&';
                    }
                }
                else if (value !== undefined && value !== null) {
                    query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
                }
            }

            return query.length ? query.substr(0, query.length - 1) : query;
        },
        toArray: function(obj) {
            var result = [];
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {
                    result.push(obj[key]);
                }
            }
            return result;
        },
        isThenable: function(value) {
            return angular.isObject(value) && angular.isFunction(value.then);
        }
    };

    var arrayExchange = function(i, j) {
        if (i !== j) {
            var tmp = this[i];
            this[i] = this[j];
            this[j] = tmp;
        }
    };

    var arrayTools = {
        shuffle: function(array) {
            var copy = array.slice();
            for (var i = copy.length - 1; i >= 0; --i) {
                arrayExchange.call(copy, i, mathTools.randomInt(i));
            }
            return copy;
        },
        generate: function(seed, count) {
            return Array.apply(null, {length: count}).map(function() {
                return seed;
            })
        },
        range: function(start, end) {
            if (end < start) {
                return [];
            }
            return Array.apply(null, {length: end - start + 1}).map(function(_, index) {
                return index + start;
            });
        },
        unique: function(array) {
            return array.reduce(function(carry, element) {
                return ~carry.indexOf(element) || carry.push(element), carry;
            }, []);
        },
        concatUnique: function(array, concat) {
            return arrayTools.unique(array.concat(concat));
        },
        randomValue: function(array) {
            var idx = mathTools.randomInt(0, array.length - 1);
            return array[idx];
        },
        empty: function(array) {
            array.splice(0);
            return array;
        },
        replace: function replace(array, data, dropHashKeys) {
            if (!angular.isArray(data)) {
                data = [];
            }
            if (!angular.isArray(array)) {
                array = [];
            }

            var minCommonLength = Math.min(data.length, array.length);
            for (var index = 0; index < minCommonLength; ++index) {
                var item = data[index];
                if (angular.isArray(item) && angular.isArray(array[index])) {
                    replace(array[index], item);
                } else if (angular.isObject(item) && angular.isObject(array[index])) {
                    objectTools.replace(array[index], item, dropHashKeys);
                } else {
                    array[index] = item;
                }
            }

            if (data.length > array.length) {
                for (index = minCommonLength; index < data.length; ++index) {
                    array.push(data[index]);
                }
            } else if (data.length < array.length) {
                array.length = data.length;
            }

            return array;
        }
    };

    var filterTools = {
        timer: function(time) {
            time = Math.ceil(time);
            if (isNaN(time)) {
                time = 0;
            }
            return [Math.floor(time / 60), time % 60].map(function(n) {
                return (n >= 10 ? '' : '0') + n;
            }).join(':');
        }
    };

    var urlTools = {
        addQueryString: function(url, args) {
            var qs = [];
            angular.forEach(args, function(value, key) {
                qs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
            });
            return qs.length ? (url + (url.indexOf('?') == -1 ? '?' : '&') + qs.join('&')) : url;
        }
    };

    var keyboardTools = {
        keys: {
            SPACE: 32,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40
        }
    };

    if (!String.prototype.trim) {
        (function() {
            // Make sure we trim BOM and NBSP
            var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
            String.prototype.trim = function() {
                return this.replace(rtrim, '');
            };
        })();
    }

    ngtk.tools = {
        math: mathTools,
        string: stringTools,
        object: objectTools,
        array: arrayTools,
        url: urlTools,
        filter: filterTools,
        keyboard: keyboardTools
    };

})(ngtk);
